<div>
  <div class="back-layer" (click)="closeClicked(false)"></div>
  <div class="add-vendor-form">
    <div class="vendors">
      <div class="vendor-header">
        <span>{{ isEdit ? 'Edit Trailer' : 'New Trailer' }}</span>
        <div class="go-back" (click)="closeClicked(false)">
          <i class="material-icons arrow">close</i>
        </div>
      </div>

      <div class="content">
        <div class="user-inputs-container">
          <form *ngIf="trailerForm" [formGroup]="trailerForm">
            <div class="flex flex-col">
              <label>Trailer Number</label>
              <mat-form-field appearance="outline">
                <input matInput type="text" formControlName="trailerName" required />
                <mat-error *ngIf="trailerForm.controls['trailerName'].hasError('required')">
                  Trailer Number is required
                </mat-error>
              </mat-form-field>
            </div>

            <div class="flex flex-col">
              <label>VIN</label>
              <mat-form-field appearance="outline">
                <input matInput type="text" formControlName="vin" />
              </mat-form-field>
            </div>

            <div class="flex flex-col">
              <label>Trailer Type</label>
              <mat-form-field appearance="outline">
                <mat-select formControlName="trailerTypeId" placeholder="Trailer Type">
                  <mat-option *ngFor="let trailerType of trailerTypes | async" [value]="trailerType.id">
                    {{ trailerType.name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div class="flex flex-col">
              <label>Region</label>
              <mat-form-field appearance="outline">
                <mat-select formControlName="trailerRegion" placeholder="Trailer Region">
                  <mat-option *ngFor="let r of regions" [value]="r">
                    {{ r }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div class="flex flex-col">
              <label>Trailer Status</label>
              <mat-form-field appearance="outline">
                <mat-select formControlName="trailerStatus" placeholder="Trailer Status">
                  <mat-option *ngFor="let s of statuses" [value]="s.key">
                    {{ s.name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div class="flex flex-col">
              <label>Subcarrier</label>
              <mat-form-field appearance="outline">
                <mat-select formControlName="subcarrierId" placeholder="Subcarrier">
                  <mat-option *ngFor="let s of subcarriers | async" [value]="s.id">
                    {{ s.name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <sa-network-active-button [active]="networkActive$$ | async">
              <button
                mat-flat-button
                color="primary"
                (click)="createOrUpdateTrailer()"
                [disabled]="trailerForm.invalid"
              >
                {{ isEdit ? 'Edit Trailer' : 'Create Trailer' }}
              </button>
            </sa-network-active-button>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
